import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "py-2 pb-6 w-full max-w-xs" }
const _hoisted_2 = { class: "tour-general-hold-tap" }
const _hoisted_3 = { class: "tour-general-firmware" }
const _hoisted_4 = { class: "join w-min" }

import { useKeyboardStore } from "@/stores";
import SettingsOption from "@/components/utils/SettingsOption.vue";
import IntegerInput from "@/components/utils/IntegerInput.vue";
import HoldTapOptions from "@/components/actions/HoldTapOptions.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'GeneralArea',
  setup(__props) {

const kb = useKeyboardStore();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[4] || (_cache[4] = _createElementVNode("h1", {
        class: "title tooltip",
        "data-tip": "Default options for Hold/Tap actions, can be overridden for each key separately"
      }, " Hold/Tap defaults ", -1)),
      _createVNode(HoldTapOptions, {
        timeout: _unref(kb).defaults.timeout,
        "onUpdate:timeout": _cache[0] || (_cache[0] = ($event: any) => ((_unref(kb).defaults.timeout) = $event)),
        tap_hold_interval: _unref(kb).defaults.tap_hold_interval,
        "onUpdate:tap_hold_interval": _cache[1] || (_cache[1] = ($event: any) => ((_unref(kb).defaults.tap_hold_interval) = $event)),
        config: _unref(kb).defaults.config,
        "onUpdate:config": _cache[2] || (_cache[2] = ($event: any) => ((_unref(kb).defaults.config) = $event))
      }, null, 8, ["timeout", "tap_hold_interval", "config"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _cache[6] || (_cache[6] = _createElementVNode("h1", {
        class: "title tooltip",
        "data-tip": "Internal firmware settings"
      }, " Firmware settings ", -1)),
      _createVNode(SettingsOption, {
        label: "Polling timeout",
        tooltip: "Timeout in milliseconds for polling other half of the keyboard when negotiating roles."
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(IntegerInput, {
              class: "w-[9ch] input-sm join-item",
              min: 100,
              max: 65535,
              modelValue: _unref(kb).config.timeout,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(kb).config.timeout) = $event))
            }, null, 8, ["modelValue"]),
            _cache[5] || (_cache[5] = _createElementVNode("span", { class: "join-item btn-input-unit btn-input-unit-sm" }, "ms", -1))
          ])
        ]),
        _: 1
      })
    ])
  ]))
}
}

})